module.exports = __webpack_public_path__ + "img/diff-3.c14b1d73.png";